<template lang="pug">
  .confirm-refill-addon-modal.clearfix
    .xs-12.text-center(v-if="addonProduct")
      p.bold.upper.xs-f-large.max-at-tweak Hello Beautiful&trade;
      p.added-text.xs-f-medium.max-at-tweak(data-mr-ass="addon-product-name") {{addonProduct.name}} will be added to your next order.
      button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type="button" @click="addAddonToRefillCart()" data-mr-ass="addon-yes-please") yes, please
      button.no-thanks.btn-reset.color-purple.xs-f-small.max-at-tweak(type="button" @click="hideModal") No, thanks

</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import vueProductSvc from '../../../../services/vueProductSvc';

  export default {
    name: "ConfirmRefillAddonModal",

    data() {
      return {
        addonProduct: null
      }
    },

    methods: {
      ...mapActions('modal', ['hideModal']),
      ...mapActions('refillCart', ['addToRefillCart']),
      ...mapGetters('refillCart', ['productIdInRefillCart']),

      addAddonToRefillCart() {
        this.addToRefillCart({
          ctaSource: {
            name: this.$route.query.cta || 'upcomingSubscriptionEmail',
            idx: this.$route.query.idx || null
          },
          product_id: this.addonProduct.id
        }).then(() => {
          this.$store.dispatch('notifySuccess', 'Great call—we’ve just added this to your upcoming order.');
        }).catch(() => {
          this.$store.dispatch('notifyError', 'We were not able to add this item to your delivery. Please try again or call Color Crew');
        }).finally(() => {
          this.hideModal();
        });
      },

      clearUrlkey() {
        var data = Object.assign({}, this.$route.query);
        data['urlKey'] = null;
        this.$router.push({ query : data });
      }
    },

    mounted() {
      if (this.$route.query.urlKey) {
        vueProductSvc.getProductByUrlKey({ urlKey: this.$route.query.urlKey }).then(res => {
          this.addonProduct = res.data;
          if (this.productIdInRefillCart(this.addonProduct.id)) {
            this.hideModal();
          }
        }).catch(() => {
          this.hideModal();
        });
      }
    },

    beforeDestroy() {
      this.clearUrlkey();
    }
  }
</script>

<style lang="stylus">
  .confirm-refill-addon-modal
    padding 1.5em 5%

    .added-text
      padding 1.5em 0

    .no-thanks
      padding 1em 0
      display block
      margin 0 auto

</style>
